<template>
  <div class="page">
    <div style="margin: 20px;padding: 0 20px;">
      <h6>每日餐次统计</h6>
    </div>
    <div class="page-inner-box">
      <div class="content">
        <div style="margin-bottom:20px;">
          <span class="topic-title">打印设置</span>
        <el-select @change="togglePrintSetting" v-model="print_way" placeholder="请选择">
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>

        <el-select style="margin: 0 12px;" v-if="print_way==2" v-model="print_driver" placeholder="请选择司机">
          <el-option
            v-for="item in driverList"
            :key="item.id"
            :label="item.username"
            :value="item.id"
          ></el-option>
        </el-select>

        </div>
        <el-row :gutter="20">
          <el-col :span="9">
            <el-input placeholder="请输入用户名称或电话查询" v-model="searchKey">
              <el-select style="width:100px;" slot="prepend" v-model="search_type" placeholder="请选择">
                <el-option
                  v-for="item in searchTypeOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
              <el-button @click="getDataList" slot="append" icon="el-icon-search"></el-button>
            </el-input>
          </el-col>
          <el-col :span="3">
            <el-button @click="onButtonPrint" type="warning" size="mini">一键打印</el-button>
          </el-col>
        </el-row>
      </div>

      <div class="my-table">
        <p class="table-title">日期： {{today}} 类型： {{type}}</p>
        <div class="table-column table-head">
          <div class="column-1">司机</div>
          <div class="column-2">企业名称</div>
          <div class="column-3">菜品名称</div>
          <div class="column-4">份数</div>
          <div class="column-5">订单状态</div>
        </div>

        <div v-for="driver in dataList" :key="driver.driver_name" class="table-column data-row">
          <div class="column-1 driver-name">{{driver.driver_name}}</div>
          <div class="column-right">
            <div v-for="company in driver.list" :key="company.inc_name" :class="['company-unit',company.order_status > 4 ? 'order-deliverd' : '']">
              <div class="column-2 company-name">{{company.inc_name}}</div>
              <div class="meal-unit">
                <div class="column-3 meal-only">
                  <div :class="['ameal',company.order_status > 4 ? 'order-deliverd' : '']">A餐：{{company.ameal_simple}}</div>
                  <div :class="['bmeal',company.order_status > 4 ? 'order-deliverd' : '']">B餐：{{company.bmeal_simple}}</div>
                </div>
                <div class="column-4">
                  <div
                    class="ameal-num"
                    :class="company.achange ? 'need-change' : '' "
                  >{{company.ameal_num}}</div>
                  <div
                    class="bmeal-num"
                    :class="company.bchange ? 'need-change' : '' "
                  >{{company.bmeal_num}}</div>
                </div>
              </div>
              <div class="column-5 order-satus">{{orderStatus[company.order_status]}}</div>
            </div>
          </div>
        </div>

        <div class="total-count">合计：{{total}}份</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      today: '',
      type: '',
      timmer: null,
      search_type: 1,
      options: [
        {
          value: 2,
          label: '手动打印',
        },
        {
          value: 1,
          label: '自动打印',
        },
      ],
      searchTypeOptions: [
        {
          value: 1,
          label: '用户名',
        },
        {
          value: 2,
          label: '电话',
        },
      ],
      print_way: 1,
      orderStatus: [
        '',
        '待付款',
        '制作中',
        '加餐确认',
        '配送中',
        '待收货',
        '已完成',
      ],
      searchKey: '',
      dataList: [],
      print_driver: null,
      driverList: [],
      total: 14,
    }
  },
  // watch: {
  //   print_way: function() {
  //     this.togglePrintSetting();
  //   }
  // },
  created() {
    this.getDataList();
    this.getDriverList();
    this.timmer = setInterval(() => {
      this.getDataList();
    }, 3000);
    this.dealTime();
  },
  destroyed() {
    clearInterval(this.timmer);
  },
  methods: {
    dealTime() {
      this.today = this.$moment().format("YYYY-MM-DD");
      var temp = this.$moment().format("YYYY/MM/DD");
      temp += ' 12:00:00';
      var noonTimeStamp = new Date(temp).getTime();
      var nowTimeStamp = Date.now();
      if (nowTimeStamp < noonTimeStamp) {
        this.type = '午餐';
      }else {
        this.type = '晚餐';
      }
      
    },
    togglePrintSetting() {
      this.$http
        .post('/api/order/printset',{ print_way: this.print_way })
        .then((res) => {
          res = res.data;
          if (res.status == 200) {
            this.$message({
              message: res.msg || "操作成功",
              type: 'success'
            });
          }else {
            this.$message.error(res.msg||"操作失败");
          }
        })
    },
    onButtonPrint() {
      var args = {driver_id: null};
      if (this.print_way == 2 && this.print_driver == null) {
        return this.$message.warning("请选择司机");
      }else {
        args.driver_id = this.print_driver;
      }

      this.$http
        .get('/api/order/print',{params:args}, {
          headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        })
        .then((res) => {
          res = res.data
          if (res.status == 200) {
            this.$message({
              message: res.msg || "操作成功",
              type: 'success'
            });
          }else {
            this.$message.error(res.msg||"操作失败");
          }
        })
    },
    getDataList() {
      var searchType = this.search_type;
      var params;
      if (searchType == 1) {
        params = {inc_name: this.searchKey};
      }else if (searchType == 2) {
        params = {tel: this.searchKey};
      }
      this.$http
        .get('/api/order/statistics', {
          params
        })
        .then((res) => {
          res = res.data
          if (res.status == '200') {
            this.dataList = res.data.list;
            this.print_way = res.data.print_way;
            this.total = res.data.total
          }
        })
    },
    getDriverList() {
      this.$http.get('/api/order/drivelist').then(res=> {
        res = res.data;
        if (res.status == '200') {
          this.driverList = [{id: 0, username: "全部"}, ...res.data];
        }
      })
    }
  },
}
</script>

<style scoped>

.page {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: #f0f0f0;
}
.page-inner-box {
  background-color: white;
  margin: 20px;
  padding: 20px;
}
.topic-title {
  margin-right: 10px;
}
.print-setting {
  background-color: red;
}
.el-row {
  margin-bottom: 20px;
}
.my-table {
  border: solid 1px #e5e5e5;
}
.table-column {
  display: flex;
  flex-flow: row nowrap;
  text-align: center;
}
.column-1,
.column-2,
.column-5 {
  display: flex;
  justify-content: center;
  align-items: center;
}
.column-1 {
  flex: 2;
}
.column-2 {
  flex: 2;
}
.column-3 {
  flex: 4;
}
.column-4 {
  flex: 1;
}
.column-5 {
  flex: 2;
}
.table-head div {
  min-height: 36px;
  border-right: solid 1px #f0f0f0;
  box-sizing: border-box;
}
.driver-name,
.company-name,
.ameal-num,
.bmeal-num,
.order-satus {
  border-bottom: solid 1px #f0f0f0;
  border-right: solid 1px #f0f0f0;
  box-sizing: border-box;
}
.column-right {
  flex: 9;
  /* background-color: red; */
  display: flex;
  flex-flow: column nowrap;
}
.company-unit {
  display: flex;
  flex-flow: row nowrap;
  /* background-color: chartreuse; */
}
.meal-unit {
  flex: 5;
  /* background-color: hotpink; */
  display: flex;
  flex-flow: row nowrap;
}
.meal-only {
  /* background-color: blue; */
  display: flex;
  flex-flow: column nowrap;
}
.ameal,
.bmeal,
.ameal-num,
.bmeal-num {
  min-height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
}
.ameal {
  background-color: #f9807b;
  color: white;
}
.bmeal {
  background-color: #96b5ec;
  color: white;
}
.need-change {
  background-color: #f29a0a;
  font-weight: bold;
  color: white;
}
/* .company-list {
  display: flex;
  flex-flow: column nowrap;
  background-color: green;
} */
/* .column-meal {
  flex: 7;
  background-color: rebeccapurple;
  
} */
.table-head {
  background-color: #dcdcdc;
}
.order-deliverd {
  background-color: #fabf67;
}
</style>
